import create from 'zustand';

import Squarespace from 'Models/Squarespace';

const [useSquarespaceStore] = create((set) => ({
	fetchingSyncOrders: false,
	syncOrders: async (params) => {
		set({ fetchingSyncOrders: true });
		console.log('call squarespace syncOrders');
		const response = await Squarespace.syncOrders(params);

		console.log('response squarespace', response);
		window.location.reload();
	},
	getSquarespaceOrder: async () => {
		console.log('call squarespace getUniqueOrder');

		const response = await Squarespace.getUniqueOrder();

		console.log('response squarespace order', response);
	}
}));

export default useSquarespaceStore;
